import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../../../utils'
import { Button, buttonModes, buttonTypes, Icon, iconNames, AccessControl } from '../../../../../../components'
import { attributesNames, userRightTypes } from '../../../../../../constants'
import { FlowElementTaskInteractionDialog } from '../FlowElementTaskInteractionDialog'
import { FlowElementTaskInteractionResourceCard } from '../FlowElementTaskInteractionResourceCard'
import '../../../common-elements-style.scss'

export const FlowElementTaskInteractionResourcesPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentTaskInstance,
  resources
  // refreshAfterSaving
}) => {
  const { t } = useTranslation()

  const resourceInteractions =
    (currentTaskInstance?.resource_interactions &&
      currentTaskInstance.resource_interactions.length > 0 &&
      currentTaskInstance.resource_interactions) ||
    null

  // -- sort the array of object to prevents from changing the display order.
  // -- the backend doesn't always returns the data in the same order.
  if (resourceInteractions) {
    resourceInteractions.sort((a, b) => (a.id > b.id ? 1 : -1))
  }

  const [openDialog, setOpenDialog] = useState(false)
  // const [resourceInteractions, setResourceInteractions] = useState(_resourceInteractions)

  useEffect(() => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionResourcesPanel.useEffect()', {
      resourceInteractions
    })

    // setResourceInteractions(_resourceInteractions)
  }, [currentTaskInstance])

  const onClickAddInteraction = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionResourcesPanel.onClickAddInteraction()', {
      openDialog
    })

    setOpenDialog(!openDialog)
  }

  // --

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskInteractionResourcesPanel.render()', {
    currentTaskInstance
    // resourceInteractions,
    // _resourceInteractions
  })

  return (
    <div className="FlowElementTaskInteractionResourcesPanel">
      <div>
        <form>
          <Grid container spacing={2} style={{ padding: '10px', marginTop: '-4px' }}>
            {/*  Buttons [+ RESOURCE]  */}
            <Grid item xs={12} sm={12} style={{ position: 'relative' }}>
              <div className="btCont">
                <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('flowActions.tasks.panels.interactions.resources.button_action.tooltip')}
                    onClick={onClickAddInteraction}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </AccessControl>
              </div>
              <div>
                {(resourceInteractions &&
                  resourceInteractions.map(
                    (el, index) =>
                      el && (
                        <FlowElementTaskInteractionResourceCard
                          key={`resource-interactions-${index}`}
                          currentProject={currentProject}
                          currentScenario={currentScenario}
                          currentFlowGroup={currentFlowGroup}
                          currentTaskInstance={currentTaskInstance}
                          currentInteraction={el}
                          // refreshAfterSaving={refreshAfterSaving}
                        />
                      )
                  )) || <i className="notFound">{t('flowActions.tasks.panels.interactions.resources.not_found')}</i>}
              </div>
            </Grid>
          </Grid>
        </form>
        {openDialog && (
          <FlowElementTaskInteractionDialog
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
            currentTaskInstance={currentTaskInstance}
            resources={resources}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            type={attributesNames.RESOURCES}
            // refreshAfterSaving={refreshAfterSaving}
          />
        )}
      </div>
    </div>
  )
}

FlowElementTaskInteractionResourcesPanel.displayName = 'FlowElementTaskInteractionResourcesPanel'

FlowElementTaskInteractionResourcesPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentTaskInstance: PropTypes.object,
  resources: PropTypes.arrayOf(PropTypes.object)
  // -- refresh after saving
  // refreshAfterSaving: PropTypes.func
}

FlowElementTaskInteractionResourcesPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentTaskInstance: null,
  resources: []
  // refreshAfterSaving: () => {}
}
